/*
 * @Description:
 * @Author: lijinpeng
 * @Date: 2022-10-11 10:22:48
 * @LastEditTime: 2025-05-06 11:19:09
 * @LastEditors: didan
 */
import Layout from '@/layout';

const waybillRouter = {
  path: `/waybill`,
  component: Layout,
  redirect: `/waybill/wdList`,
  alwaysShow: true, // will always show the root menu
  name: 'Waybill',
  meta: {
    id: 2,
    title: '运单管理',
    icon: 'yzs_wanghuo',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
  },
  children: [
    {
      path: 'wdList',
      component: () => import('@/views/waybillWd/list/index'),
      name: 'WaybillWd',
      meta: {
        id: 21,
        title: '运单管理',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'expireWdList',
      component: () => import('@/views/waybillWd/list/expireList'),
      name: 'expireWdList',
      meta: {
        id: 22,
        title: '过期运单',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    // {
    //   path: 'zyList',
    //   component: () => import('@/views/waybillZy/list/index'),
    //   name: 'waybillZy',
    //   meta: {
    //     title: '自有车',
    //     roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_ZY'],
    //   },
    // },
  ],
};
export default waybillRouter;
